import { createContext } from "react";
import type { ProductOption } from "./productLabels";

export interface ProductLabelsValue {
  labels: ReadonlyMap<string, string>;
  /** Поле с выбранными продуктами просит их названия. */
  request: (ids: readonly string[]) => void;
  /** Названия, которые поле уже знает (выбранный вариант). */
  remember: (options: readonly ProductOption[]) => void;
}

/** Общие названия продуктов редактора (ProductLabelsProvider). */
export const ProductLabelsContext = createContext<ProductLabelsValue | null>(
  null
);
